import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import SvcPersetujuanPlebotomi from "@/services/PersetujuanPlebotomi";

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "persetujuan-plebotomi"
})
class PersetujuanPlebotomi extends VuexModule {
  suket: any[] = [];

  loading = false;

  registerId: string | null = null;

  @Mutation
  SET_SUKET(suket: any[]) {
    this.suket = suket || [];
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation
  SET_REGISTER_ID(val: string | number | null) {
    this.registerId = val === null || val === undefined ? null : String(val);
  }

  @Mutation
  RESET() {
    this.suket = [];
    this.loading = false;
    this.registerId = null;
  }

  @Action({ rawError: true })
  async getSuketByRegister(noReg: string | number): Promise<void> {
    if (this.registerId !== String(noReg)) {
      this.SET_SUKET([]);
    }

    this.SET_REGISTER_ID(noReg);
    this.SET_LOADING(true);

    try {
      const result = await SvcPersetujuanPlebotomi.getByRegister(noReg);

      if (this.registerId !== String(noReg)) return;

      this.SET_SUKET((result && result.data) || []);
    } catch {
      if (this.registerId === String(noReg)) {
        this.SET_SUKET([]);
      }
    } finally {
      this.SET_LOADING(false);
    }
  }

  @Action
  reset() {
    this.RESET();
  }
}

export default getModule(PersetujuanPlebotomi);
